import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getFirstOpenFormIndex,
  getPracticeFormIdsArray,
  getPracticePatientId,
} from "../../../core/store/currentFormSlice";
import { useMainStore } from "../../../core/store/mainStore";

/**
 * Starts a form run at the first form the record has not submitted on this device today, and ends it on the link's
 * end screen when none is left, so that a completed link does not start over. Decided once, when the run starts.
 */
export const useSkipSubmittedForms = (): boolean => {
  const practicePatientId = useMainStore(getPracticePatientId);
  const startRunAt = useMainStore((state) => state.startRunAt);
  const navigate = useNavigate();
  const [decided, setDecided] = useState(false);

  useEffect(() => {
    if (!practicePatientId) return;
    const state = useMainStore.getState();
    if (!getPracticeFormIdsArray(state)) {
      setDecided(true);
      return;
    }
    const openIndex = getFirstOpenFormIndex(state);
    if (openIndex === -1) {
      navigate("/welcome/success", { replace: true, state: { allFormsCompleted: true } });
      return;
    }
    startRunAt(openIndex);
    setDecided(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practicePatientId]);

  return decided;
};
